import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { Link } from 'gatsby';
import LogoIcon from '../../svg/LogoIcon';
import ContactButton from '../ContactButton';

const Header = ({ location }) => (
  <header className="sticky top-0 bg-white shadow z-10">
    <div className="container flex flex-col sm:flex-row justify-between items-center mx-auto py-4 px-8">
      <Link to="/">
        <div className="flex items-center text-2xl">
          <div className="mr-3">
            <LogoIcon className="w-full" />
          </div>
        </div>
      </Link>
      {location.pathname === '/' && (
        <div className="flex mt-4 sm:mt-0">
          <AnchorLink className="px-4" href="#stats">
            Stats
          </AnchorLink>
          <AnchorLink className="px-4" href="#services">
            Services
          </AnchorLink>
          <AnchorLink className="px-4" href="#projects">
            Projects
          </AnchorLink>
        </div>
      )}
      <div className="hidden md:block">
        <ContactButton className="text-sm">Contact</ContactButton>
      </div>
    </div>
  </header>
);

export default Header;
